module.exports = __webpack_public_path__ + "static/media/edit_project.077cdc77.svg";